import { Box, Container, Flex } from '@chakra-ui/react';
import React from 'react';

import Nav from '../../components/Nav/Nav';

type SimpleLayoutProps = {
  children: React.ReactNode;
  background?: string;
  banner?: React.ReactNode;
};

const SimpleLayout = ({ children, background, banner }: SimpleLayoutProps) => {
  return (
    <Flex bg="grayBackground" minH="100dvh" flexDirection="column">
      {banner}
      <Box>
        <Nav hideMenuItems hideAuthOptions />
      </Box>
      <Box bg={background} flexGrow={1}>
        <Container maxW="container.xl">{children}</Container>
      </Box>
    </Flex>
  );
};

export default SimpleLayout;
